import React from 'react'
import { config } from 'config'
import { Link } from 'react-router'
import { prefixLink } from 'gatsby-helpers'
import Helmet from 'react-helmet'
import { Container } from 'react-responsive-grid'
import { rhythm } from '../../utils/typography'
import { Scrollspy } from 'react-scrollspy'
import { TiArrowLeft } from 'react-icons/lib/ti'
import PortfolioSection from 'components/PortfolioSection'
import works from 'data/works'
import workCategories from 'data/work-categories'


export default class Index extends React.Component {
  
  constructor() {
    super();
    this.state = {
      isBrowser: false
    };
  }

  componentDidMount() {
    this.setState({isBrowser: true});
  }

  renderScrollSpy() {
    return <div className="scrollspy">
      <Scrollspy items={ ['section-projects', 'section-awards'] } currentClassName="is-current" offset={-250}>
        <li><a href="#section-projects">PROJECTS</a></li>
        <li><a href="#section-awards">AWARDS</a></li>
      </Scrollspy>
    </div>;
  }

  render () {
    const masonryOptions = {
      transitionDuration: 0,
      fitWidth: true,
      gutter: 30
    };

    return (
      <div>
        <Helmet
          title={config.siteTitle}
          meta={[
            {"name": "description", "content": "Sample"},
            {"name": "keywords", "content": "sample, something"},
          ]}
        />
        <Container
            style={{
              maxWidth: 960,
              paddingTop: 100
            }}
            id="section-projects"
          >
          
          <div className="section-header">
            <a href="/" className="section-header-link"><TiArrowLeft className="icon-back"/></a>
            <h2>Works</h2>
            <p>Selected Projects</p>
          </div>
          
          <PortfolioSection works={works} workCategories={workCategories} />
        </Container>
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./works/index.js
 **/